import { Outlet } from "react-router";
import { LinkTabs, Page, PageHeader, type LinkTabItem } from "@/ui";
import { useTabBarSlotRef } from "@/layout/PageChrome";

/**
 * The Settings shell, shared by the super admin and every org admin.
 *
 * Branding used to be its own sidebar entry sitting next to Settings, which
 * split one idea — "how this thing is configured" — across two places in the
 * nav. It is now a tab, and the sidebar is shorter for it.
 *
 * The tabs are links (see `LinkTabs`), so "send me the branding tab" is a URL
 * and a refresh keeps your place. This component owns the one `<h1>`; a panel
 * that adds its own heading would stack two titles under each other.
 */
export function SettingsLayout({
  description,
  tabs,
}: {
  description?: string;
  tabs: readonly LinkTabItem[];
}) {
  // Panels render their own Save into the end of the tab row rather than
  // stacking a second row under it (see PageChrome).
  const tabBarSlot = useTabBarSlotRef();

  return (
    <Page className="gap-4">
      <PageHeader description={description} divider={false} title="Settings" />
      <LinkTabs items={tabs} trailing={<div ref={tabBarSlot} className="flex items-center gap-3" />} />
      {/* The active panel decides for itself whether it fills or scrolls —
          Branding fills to align its three columns, General scrolls. */}
      <Outlet />
    </Page>
  );
}
